<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="primary">
            <h4 class="title">Altere os dados de sua rede Wi-Fi</h4>
            <small
              >Você pode trocar a senha e o nome da sua rede por aqui!</small
            >
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Selecione um plano</label>
                  <md-select placeholder="Selecione um plano" v-model="pointId">
                    <md-option
                      v-for="point in points"
                      :key="point.id"
                      :value="point.id"
                    >
                      {{ point.address }}, {{ point.address_number }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-33">
                <md-field>
                  <label>Senha da sua rede Wi-Fi</label>
                  <md-input min="8" v-model="password"></md-input>
                </md-field>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <div class="d-flex flex-row-reverse">
          <md-button @click="changeWifi()" class="btn-contract">
            Salvar configurações
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  name: "simple-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    points() {
      return this.$store.getters.points.filter(point => point.groupId === 27);
    }
  },
  data() {
    return {
      pointId: null,
      password: ""
    };
  },
  methods: {
    ...mapActions(["fetchPoints"]),
    userToken() {
      return localStorage.getItem("gerenariAccessToken");
    },
    async changeWifi() {
      if (!this.pointId) {
        Swal.fire("Ops!", "Selecione um ponto para prosseguir.", "error");
        return;
      }
      if (!this.password) {
        Swal.fire("Ops!", "Digite a senha da sua rede.", "error");
        return;
      }
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Ao prosseguir você irá alterar os dados de sua rede, prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });
      if (result.isConfirmed) {
        try {
          Swal.fire({
            title: "Aguarde",
            html: "Carregando...",
            allowOutsideClick: false,
            didOpen: async () => {
              Swal.showLoading();
              try {
                await axios.put(
                  `https://gerenari-api.hubnari.com.br/central/points/${this.pointId}/gpon`,
                  {
                    password: this.password
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${this.userToken()}`
                    }
                  }
                );
                Swal.hideLoading();
                Swal.fire("Sucesso!", "Dados alterado", "success");
              } catch (e) {
                Swal.close();
                if (e.response.status === 404) {
                  const result = await Swal.fire({
                    title: "Atenção!",
                    text:
                      "Seu equipamento ainda não esta pronto para isso, não se preocupe, entre em contato com nosso suporte que configuramos para você.",
                    icon: "warning",
                    focusConfirm: false,
                    reverseButtons: true,
                    showCancelButton: true,
                    confirmButtonColor: "#9dcf6b",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Ok",
                    cancelButtonText: "Falar com suporte"
                  });
                  if (!result.isConfirmed) {
                    window.open(
                      "http://api.whatsapp.com/send?1=pt_BR&phone=5511996047878"
                    );
                  }
                } else {
                  Swal.fire(
                    "Ops!",
                    "Não foi possível completar a ação.",
                    "error"
                  );
                }
              }
            }
          });
        } catch (e) {
          Swal.close();
          Swal.fire("Ops!", "Não foi possível completar a ação.", "error");
        }
      }
    }
  },
  async mounted() {
    await this.fetchPoints({ id: this.user.id });
  }
};
</script>

<style lang="scss" scoped>
.btn-contract {
  background-color: var(--primary-color) !important;

  &:hover {
    background-color: var(--secondary-color) !important;
  }
}
</style>
